import { render, staticRenderFns } from "./updateHistoryModal.vue?vue&type=template&id=5c6bfa3b&scoped=true&"
import script from "./updateHistoryModal.vue?vue&type=script&lang=js&"
export * from "./updateHistoryModal.vue?vue&type=script&lang=js&"
import style0 from "./updateHistoryModal.vue?vue&type=style&index=0&id=5c6bfa3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6bfa3b",
  null
  
)

export default component.exports